<template>
    <v-dialog v-model="showDialog" max-width="500px" max-height="300" 
    :fullscreen="$vuetify.display.xs"
     @afterLeave="closeDialog()">
     <v-container    class="py-0" >
    <v-row no-gutters  align="start" justify="center" >
    <v-col cols="auto" > 
      <v-card
        class="ma-0 pa-0"

        max-width="500"
        title="Вы не авторизованы"
        subtitle="Необходимо выполнить вход"
        elevation="1">
        <template v-slot:append>
        <v-btn icon="$close" variant="text" @click="closeDialog"></v-btn>
        </template>
        <template v-slot:prepend>
          <v-avatar color="blue-lighten-1" size="large">
            <v-icon icon="mdi mdi-login" size="x-large"></v-icon>
          </v-avatar>
        </template>
        <v-card-item class="text-center">
          <v-btn 
           variant="text" 
           color="blue-lighten-1"
           class="mr-3"
           block
          @click="goToLogin">Перейти на страницу входа</v-btn>
      
        </v-card-item>
        <v-card-actions>
          <v-btn
          @click="closeDialog"
          variant="text" 
           color="grey-darken-1"
           class="mr-3"
           block
          >Позже</v-btn>
        </v-card-actions>
      
      </v-card>
    </v-col>   
  
</v-row>

</v-container>
    </v-dialog>
  </template>
  
  <script setup>
  import { useUserStore } from '@/stores/userStore';
  import { useRouter } from 'vue-router';
  import { computed } from 'vue';
  const authStore = useUserStore();
  const router = useRouter();


  const showDialog = computed({
  get: () => authStore.showDialog,
  set: (value) => (authStore.showDialog = value),
});


  // Деструктуризация состояний и методов из store
  
  const closeDialog = () => {
    authStore.closeDialogNotAuth()
  };
  
  const goToLogin = () => {
    authStore.closeDialogNotAuth() // Закрываем диалог
    router.push('/auth/login_methods/email'); // Переходим на страницу входа
  };
  </script>
  
  <style scoped>

  @media (max-width: 600px) {
  .v-overlay__content {
    margin-left: 16px; /* Отступ слева */
    margin-right: 16px; /* Отступ справа */
    width: calc(100% - 32px); /* Ширина диалога с учетом отступов */
    max-width: none; /* Убираем ограничение по максимальной ширине */
    display: flex;
    align-items: center; /* Выравнивание по вертикали */
    justify-content: center; /* Выравнивание по горизонтали */
    height: 100%; /* Занимает всю высоту */
  }

  .v-card {
    width: 100%; /* Карточка занимает всю ширину контейнера */
  }
}
  </style>